import script from "./WeatherWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./WeatherWidget.vue?vue&type=script&setup=true&lang=js"

import "./WeatherWidget.vue?vue&type=style&index=0&id=6f82bb1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f82bb1a"]])

export default __exports__